import { useEffect, useState } from "react";
import { closeLoading, notifyLoading, notifySuccess } from "src/assets/toastService";
import { EmployeeInterface } from "src/shared/services/interface";
import { deleteEmployee, editEmployee, getEmployee, postEmployee } from "src/shared/services/services";
import { errorHandling } from "src/shared/utils/errorHandling";

function useEmployee() {
  const [employee, setEmployee] = useState<EmployeeInterface[]>([]);
  const [isLoadingStaff, setIsLoading] = useState<boolean>(false);

  // Fetch employees
  const fetchEmployee = () => {
    setIsLoading(true);
    getEmployee()
      .then((res: any) => {
        const employeeData: EmployeeInterface[] = res.data.result;
        console.log(employeeData);
        setEmployee(employeeData);
        setIsLoading(false);
      })
      .catch((err: any) => {
        errorHandling(err);
        setIsLoading(false);
      });
  };

  // Add or update employee
  const saveEmployee = (data: any, closeData: () => void, errorData: () => void) => {
    notifyLoading("Please wait, Employee is being saved...");
    postEmployee(data)
      .then((res: any) => {
        closeLoading();
        notifySuccess("Employee saved successfully");
        fetchEmployee();
        closeData();
      })
      .catch((err: any) => {
        closeLoading();
        errorHandling(err);
        errorData();
      });
  };

  const changeEmployee = (id: any, data: any, closeData: () => void, errorData: () => void) => {
    notifyLoading("Please wait, Employee is being updating...");
    editEmployee(id, data)
      .then((res: any) => {
        closeLoading();
        notifySuccess("Employee updated successfully");
        fetchEmployee();
        closeData();
      })
      .catch((err: any) => {
        closeLoading();
        errorHandling(err);
        errorData();
      });
  };

  const Refetch = () => {
    fetchEmployee();
  };

  const deleteConfirm = (id: any, closeData: () => void) => {
    deleteEmployee(id)
      .then((res: any) => {
        closeLoading();
        notifySuccess("Employee updated successfully");
        fetchEmployee();
        closeData();
      })
      .catch((err: any) => {
        closeLoading();
        errorHandling(err);
      });
  };

  // Fetch on mount
  useEffect(() => {
    fetchEmployee();
  }, []);

  return { employee, fetchEmployee, saveEmployee, changeEmployee, isLoadingStaff, Refetch, deleteConfirm };
}

export default useEmployee;
